module.exports = __webpack_public_path__ + "img/loader.e32ac6c3.svg";